// Simple URL encoding for submission IDs
export const encodeId = (id) => {
  return btoa(`sub_${id}_${Math.random().toString(36).substr(2, 4)}`).replace(/[+/=]/g, '');
};

export const decodeId = (encodedId) => {
  try {
    const decoded = atob(encodedId);
    const match = decoded.match(/^sub_(\d+)_/);
    return match ? parseInt(match[1]) : null;
  } catch {
    return null;
  }
};